<div class="row">
    <span class="groupTitle"> {{groupValue}}</span>
    <div *ngFor="let column of aggFuncColumns" class="aggFun" [style.width.px]="column.width"
        [style.left.px]="column.left" [hidden]="isCellHidden(column)">
        {{column.value}}
    </div>
</div>
